"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

exports.__esModule = true;

var React = require("react");

var emotion_theming_1 = require("emotion-theming");

var elements_1 = require("./elements");

var Formatted_1 = require("./message-parsers/Formatted");

var Object_1 = require("./message-parsers/Object");

var Error_1 = require("./message-parsers/Error");

var ConsoleMessage =
/** @class */
function (_super) {
  __extends(ConsoleMessage, _super);

  function ConsoleMessage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.theme = function (theme) {
      return __assign({}, theme, {
        method: _this.props.log.method
      });
    };

    return _this;
  }

  ConsoleMessage.prototype.render = function () {
    var log = this.props.log;
    return React.createElement(emotion_theming_1.ThemeProvider, {
      theme: this.theme
    }, React.createElement(elements_1.Message, {
      "data-method": log.method
    }, React.createElement(elements_1.Icon, null), React.createElement(elements_1.Content, null, this.getNode())));
  };

  ConsoleMessage.prototype.getNode = function () {
    var log = this.props.log; // Error handling

    var error = this.typeCheck(log);
    if (error) return error; // Chrome formatting

    if (log.data.length > 0 && typeof log.data[0] === 'string' && log.data[0].indexOf('%') > -1) {
      return React.createElement(Formatted_1["default"], {
        data: log.data
      });
    } // Error panel


    if (log.data.every(function (message) {
      return typeof message === 'string';
    }) && log.method === 'error') {
      return React.createElement(Error_1["default"], {
        log: log
      });
    } // Normal inspector


    var quoted = typeof log.data[0] !== 'string';
    return React.createElement(Object_1["default"], {
      log: log,
      quoted: quoted
    });
  };

  ConsoleMessage.prototype.typeCheck = function (log) {
    if (!log) {
      return React.createElement(Formatted_1["default"], {
        data: ["%c[console-feed] %cFailed to parse message! %clog was typeof " + typeof log + ", but it should've been a log object", 'color: red', 'color: orange', 'color: cyan']
      });
    } else if (!(log.data instanceof Array)) {
      return React.createElement(Formatted_1["default"], {
        data: ['%c[console-feed] %cFailed to parse message! %clog.data was not an array!', 'color: red', 'color: orange', 'color: cyan']
      });
    }

    return false;
  };

  return ConsoleMessage;
}(React.PureComponent);

exports["default"] = ConsoleMessage;